export default __webpack_public_path__ + "static/media/Home Shifting.2fa1e124.png";